import ApiRequest from "../../actions/ApiRequest.js";
import { END_POINTS, HTTP_METHODS } from "./endPoints.js";
import { LOCAL_STORAGE_ITEMS_ENUM } from "../constants/localStorageItemsEnum.js";
import {
  AZY_ID,
  HOT_ID,
  JAWWAL_ID,
  OOREDOO_ID,
} from "shared/constants/constants.js";

const {
  getJawwalBundles,
  checkNumberProvider,
  getPeletalkProducts,
  getAzyProducts,
  getHotProducts,
  getOoredooBundles,
  getAllSellers,
  carrierCheck,
  nedcoEnquiry,
  selcoEnquiry,
  selcoBuyVoucher,
  syncAccounts,
  nedcoBuyVoucher,
  getPaltelBills,
  verifyPaltelNumber,
  verifyMadaNumber,
  getMadaBills,
  payMadaBill,
  getCoolnetBills,
  payGemzoBill,
  getGemzoBills,
  verifyGemzoNumber,
  verifyCoolnetNumber,
  payCoolnetBill,
  payJawwalBill,
  getJawwalBills,
  payOoredooBill,
  getOoredooBills,
  payPaltelBill,
  getBnetBills,
  payBnetBill,
  updateFawriBundles,
} = END_POINTS;

export async function getJawwalBundlesApiCaller({
  language,
  refresh,
  mobileNumber,
  bundle = "3g",
}) {
  const lang =
    language || localStorage.getItem(LOCAL_STORAGE_ITEMS_ENUM.langCity);
  return;
  return await ApiRequest.post(
    getJawwalBundles.url
      .replace("{mobileNumber}", mobileNumber)
      .replace("{bundle}", bundle)
      .replace("{language}", lang)
      .replace("{refresh}", refresh)
  );
}

export async function checkNumberProviderApiCaller({
  mobileNumber = "",
  carrier = "",
}) {
  return await ApiRequest.post(
    checkNumberProvider.url
      .replace("{mobileNumber}", mobileNumber)
      .replace("{carrier}", carrier)
  );
}

export async function getPeletalkProductsApiCaller({ providerId = "" }) {
  return await ApiRequest.post(
    getPeletalkProducts.url.replace("{providerId}", providerId)
  );
}

export async function getAzyProductsApiCaller({ language }) {
  return await ApiRequest.post(
    getAzyProducts.url.replace("{language}", language)
  );
}

export async function getHotProductsApiCaller({ language }) {
  return await ApiRequest.post(
    getHotProducts.url.replace("{language}", language)
  );
}

export async function getOoredooBundlesApiCaller({ bundle, language }) {
  return await ApiRequest.post(
    getOoredooBundles.url
      .replace("{bundle}", bundle)
      .replace("{language}", language)
  );
}

export async function carrierCheckApiCaller({ mobileNumber }) {
  return await ApiRequest.post(
    carrierCheck.url.replace("{mobileNumber}", mobileNumber)
  );
}

export async function getAllSellersApiCaller({ resellerId = "" }) {
  return await ApiRequest.post(
    getAllSellers.url.replace("{resellerId}", resellerId)
  );
}

export async function syncAccountApiCaller({ sellerId, fix }) {
  return await ApiRequest.post(
    syncAccounts.url.replace("{sellerId}", sellerId).replace("{fix}", fix)
  );
}

export async function nedcoEnquiryApiCaller({ sNumber, amount }) {
  return await ApiRequest.post(
    nedcoEnquiry.url.replace("{s_number}", sNumber).replace("{amount}", amount)
  );
}

export async function selcoEnquiryApiCaller({ sNumber, amount }) {
  return await ApiRequest.post(
    selcoEnquiry.url.replace("{s_number}", sNumber).replace("{amount}", amount)
  );
}
export async function nedcoBuyVoucherApiCaller({ sNumber, amount }) {
  return await ApiRequest.post(
    nedcoBuyVoucher.url
      .replace("{s_number}", sNumber)
      .replace("{amount}", amount)
  );
}
export async function selcoBuyVoucherApiCaller({ sNumber, amount }) {
  return await ApiRequest.post(
    selcoBuyVoucher.url
      .replace("{s_number}", sNumber)
      .replace("{amount}", amount)
  );
}

export async function getPaltelBillsApiCalled({ number, id }) {
  const { data } = await ApiRequest(getPaltelBills.url, {
    method: getPaltelBills.method,
    params: {
      number,
      id,
    },
  });
  return data;
}

export async function getMadaBillsApiCalled({ number, id }) {
  const { data } = await ApiRequest(getMadaBills.url, {
    method: getMadaBills.method,
    params: {
      number,
      id,
    },
  });
  return data;
}
export async function getCoolnetBillsApiCalled({ number, id }) {
  const { data } = await ApiRequest(getCoolnetBills.url, {
    method: getCoolnetBills.method,
    params: {
      number,
      id,
    },
  });
  return data;
}

export async function getGemzoBillsApiCalled({ number, id }) {
  const { data } = await ApiRequest(getGemzoBills.url, {
    method: getGemzoBills.method,
    params: {
      number,
      id,
    },
  });
  return data;
}
export async function getBnetBillsApiCalled({ number }) {
  const { data } = await ApiRequest(getBnetBills.url, {
    method: getBnetBills.method,
    params: {
      number,
    },
  });
  return data;
}

export async function getJawwalBillsApiCalled({ number }) {
  const { data } = await ApiRequest(getJawwalBills.url, {
    method: getJawwalBills.method,
    params: {
      number,
    },
  });
  return data;
}

export async function getOoredooBillsApiCalled({ number }) {
  const { data } = await ApiRequest(getOoredooBills.url, {
    method: getOoredooBills.method,
    params: {
      number,
    },
  });
  return data;
}

export async function getPaltelIdRequirementApiCalled({ number }) {
  const { data } = await ApiRequest(verifyPaltelNumber.url, {
    method: verifyPaltelNumber.method,
    params: {
      number,
    },
  });

  return data;
}

export async function verifyMadaNumberApiCalled({ number }) {
  const data = await ApiRequest(verifyMadaNumber.url, {
    method: verifyMadaNumber.method,
    params: {
      number,
    },
  });

  return !!data.request.response?.toString();
}

export async function verifyCoolnetNumberApiCalled({ number }) {
  const data = await ApiRequest(verifyCoolnetNumber.url, {
    method: verifyCoolnetNumber.method,
    params: {
      number,
    },
  });

  return !!data.request.response?.toString();
}

export async function verifyGemzoNumberApiCalled({ number }) {
  const data = await ApiRequest(verifyGemzoNumber.url, {
    method: verifyGemzoNumber.method,
    params: {
      number,
    },
  });

  return !!data.request.response?.toString();
}

export async function payPaltelBillApiCalled({
  number,
  amount,
  wNumber,
  email,
  paymentMode,
  identity,
  billDetails,
  billId,
  yearMonth,
}) {
  const params = {
    number,
    amount,
    w_number: wNumber,
    email,
  };

  if (paymentMode) {
    params.payment_mode = paymentMode;
  }

  if (identity) {
    params.id = identity;
  }

  if (billId) {
    params.bill_id = billId;
  }

  if (yearMonth) {
    params.period = yearMonth;
  }

  const requestConfig = {
    method: payPaltelBill.method,
    params,
  };

  if (billDetails) {
    requestConfig.data = { bill_details: billDetails };
  }

  const { data } = await ApiRequest(payPaltelBill.url, requestConfig);
  return data;
}
export async function payMadaBillApiCalled({ service_number, invoice_number, amount, billing_period, wNumber, email }) {
  console.log("🔍 Mada API Caller - Parameters:", { service_number, invoice_number, amount, billing_period, wNumber, email });

  const { data } = await ApiRequest(payMadaBill.url, {
    method: payMadaBill.method,
    params: {
      service_number,
      invoice_number,
      amount,
      billing_period,
      w_number: wNumber,
      email,
    },
  });
  console.log("🔍 Mada API Caller - Response:", data);
  return data;
}

export async function payCoolnetBillApiCalled({
  number,
  amount,
  wNumber,
  email,
}) {
  const { data } = await ApiRequest(payCoolnetBill.url, {
    method: payCoolnetBill.method,
    params: {
      number,
      amount,
      w_number: wNumber,
      email,
    },
  });
  return data;
}
export async function payGemzoBillApiCalled({
  number,
  amount,
  wNumber,
  email,
}) {
  const { data } = await ApiRequest(payGemzoBill.url, {
    method: payGemzoBill.method,
    params: {
      number,
      amount,
      w_number: wNumber,
      email,
    },
  });
  return data;
}

export async function payJawwalBillApiCalled({
  number,
  amount,
  id,
  wNumber,
  email,
  billDetails,
  identity,
  provider = "jawwal",
}) {
  const payload = {
    number,
    id,
    amount,
    w_number: wNumber,
    email,
    identity: identity || "N/A",
    provider,
    timestamp: new Date().toISOString(),
  };

  // Add comprehensive bill details if provided
  if (billDetails && Array.isArray(billDetails)) {
    payload.bill_details = billDetails.map(bill => ({
      bill_id: bill.id,
      bill_number: bill.bill_number || bill.number,
      amount: bill.amount,
      date: bill.date || bill.date1,
      due_date: bill.due_date,
      status: bill.status,
      description: bill.description || bill.type,
      service_period: bill.service_period,
      previous_balance: bill.previous_balance,
      payment_amount: bill.payment_amount,
      new_balance: bill.new_balance,
      tax_amount: bill.tax_amount,
      fees: bill.fees,
    }));
  }

  const { data } = await ApiRequest(payJawwalBill.url, {
    method: payJawwalBill.method,
    params: payload,
  });
  return data;
}

export async function payOoredooBillApiCalled({
  number,
  amount,
  wNumber,
  email,
  id,
  period,
}) {
  const payload = {
    number,
    amount,
    w_number: wNumber,
    email,
    id,
    period: period || id,
  };

  const { data } = await ApiRequest(payOoredooBill.url, {
    method: payOoredooBill.method,
    params: payload, // Send in query as fallback
    data: payload,   // Send in body as primary
  });
  return data;
}
export async function payBnetBillApiCalled({
  number,
  amount,
  wNumber,
  email,
}) {
  const { data } = await ApiRequest(payBnetBill.url, {
    method: payBnetBill.method,
    params: {
      number,
      amount,
      w_number: wNumber,
      email,
    },
  });
  return data;
}

export async function updateFawriBundlesApiCalled() {
  // Set 10 minute timeout for bundle extraction (600000ms)
  // This operation takes a long time as it scrapes the Ooredoo website
  return await ApiRequest.post(updateFawriBundles.url, {}, {
    timeout: 600000 // 10 minutes
  });
}

export function getProviderAPiCaller(providerId = "", bundleType = "") {
  if (PROVIDER_ID_TO_BUNDLE_API_CALLER[providerId]) {
    return PROVIDER_ID_TO_BUNDLE_API_CALLER[providerId];
  }
  return getPeletalkProductsApiCaller;
}

export function makeXMLRequest({ url, method = HTTP_METHODS, body }) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method.post, url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        resolve(xhr.response);
      } else reject(xhr.response);
    };
    xhr.send(body);
  });
}

const PROVIDER_ID_TO_BUNDLE_API_CALLER = {
  [JAWWAL_ID]: getJawwalBundlesApiCaller,
  [OOREDOO_ID]: getOoredooBundlesApiCaller,
  [HOT_ID]: getHotProductsApiCaller,
  [AZY_ID]: getAzyProductsApiCaller,
};
